import { render, staticRenderFns } from "./versionFilmRecordByDate.vue?vue&type=template&id=4b369922&scoped=true&"
import script from "./versionFilmRecordByDate.vue?vue&type=script&lang=js&"
export * from "./versionFilmRecordByDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b369922",
  null
  
)

export default component.exports